import { createContext, useContext } from "react";

export type LockAppStatus = {
  type: "lock_app_status";
  is_lock: boolean;
  task_id: string | null;
  timestamp: string | null;
};

export const isLockAppStatus = (data: unknown): data is LockAppStatus =>
  typeof data === "object" &&
  data !== null &&
  (data as LockAppStatus).type === "lock_app_status";

export type WsContextType = {
  wsData: unknown;
  isConnected: boolean;
};

export const WsContext = createContext<WsContextType>({
  wsData: null,
  isConnected: false,
});

export const useWs = () => useContext(WsContext);
